import React from 'react'
import { useDrag } from 'react-dnd'
import moment from 'moment'
import FeatherIcon from 'feather-icons-react'
const style = {
  border: '1px dashed gray',
  backgroundColor: 'white',
  padding: '0.1rem 0.5rem',
  marginRight: '1.5rem',
  marginBottom: '0.5rem',
  cursor: 'move',
  width: '100%',
}

export const buildBox = (item) => {
  if (item.type == 'date') {
    item.format = 'YYYY-MM-DD HH:mm'
    // item.value = 'hello'
  }

  if (item.type === 'texteditor') {
    item.sourceCode = ''
    item.styleData = ''
  }
  //console.log('bb',item)
  return item
}

export const ConfigItem = ({
  item,
  icon = null,
  accent = '#4099ff',
  description = '',
  className = '',
}) => {
  const { name } = item
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'box',
    item: item,
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult()
      const delta = monitor.getDifferenceFromInitialOffset()
      if (item && dropResult) {
        //console.log(`You dropped ${item.name} `,item,dropResult,delta,monitor);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
    isDragging: (monitor) => {
      const delta = monitor.getDifferenceFromInitialOffset()
      //console.log("isDragging",monitor,delta)
    },
  }))
  const opacity = isDragging ? 0.4 : 1
  const itemStyle = className
    ? { opacity, '--resource-accent': accent }
    : { ...style, opacity }

  return (
    <div
      ref={drag}
      role="Box"
      style={itemStyle}
      className={className}
      data-accent={accent}
      data-testid={`box-${name}`}
      title={description || undefined}
    >
      {icon && (
        <span className="config-item-icon" style={{ color: accent }}>
          <FeatherIcon size="18" icon={icon} />
        </span>
      )}
      <span className="config-item-content">
        <span className="config-item-name">{name}</span>
        {description && (
          <span className="config-item-description">{description}</span>
        )}
      </span>
      {icon && (
        <span className="config-item-drag" aria-hidden="true">
          <FeatherIcon size="15" icon="move" />
        </span>
      )}
    </div>
  )
}
